{{if field.isCascade != 1}}
<% include('./select-single.art', {field: field, type: type}) %>
{{/if}}
{{if field.isCascade == 1}}
<% include('./select-many.art', {field: field, type: type}) %>
{{/if}}